export function isFoneFixo(fone: string): boolean {
  const FONE: string = `${fone}`.replace(/[^\d]+/g, '');
  return !!(FONE && FONE.length === 10);
}
